import { createReducer, on } from '@ngrx/store';
import { initialUIState } from './portfolios.state';
import * as PortfoliosActions from './portfolios.actions';

export const portfoliosReducer = createReducer(
  initialUIState,
  on(PortfoliosActions.togglePortfoliosByTypeLoading, (state, { loading }) => ({
    ...state,
    isLoadingByType: loading,
  })),
  on(PortfoliosActions.loadPortfoliosByTypeSuccess, (state, { portfolios }) => ({
    ...state,
    portfoliosByType: portfolios,
    isLoadingByType: false,
  })),
  on(PortfoliosActions.loadPortfoliosByTypeFailure, (state) => ({
    ...state,
    portfoliosByType: [] as any[],
    isLoadingByType: false,
  })),
  on(PortfoliosActions.toggleAllPortfoliosLoading, (state, { loading }) => ({
    ...state,
    isLoadingAll: loading,
  })),
  on(PortfoliosActions.loadAllPortfoliosSuccess, (state, { portfolios }) => ({
    ...state,
    allPortfolios: portfolios,
    isLoadingAll: false,
  })),
  on(PortfoliosActions.loadAllPortfoliosFailure, (state) => ({
    ...state,
    allPortfolios: [] as any[],
    isLoadingAll: false,
  }))
);